// 合同作废页面
<template>
  <div class="cancel-root">
    <p class="title">
      <span class="icon-sty"></span>作废协议
    </p>
    <div class="contract-sty">
      <el-row :gutter="20">
        <el-col :span="19">
          <div class="right-contract-box">
            <contract :INVALI="INVALI" :cancelForm="cancelForm" :reasonSet="reasonSet"></contract>
          </div>
        </el-col>
        <el-col :span="5">
          <div class="left-input-box">
            <el-form
              :model="cancelForm"
              :rules="rules"
              ref="cancelFormRef"
              class="form-sty"
              label-position="top"
              size="small"
            >
              <el-form-item label="作废原因：" prop="reason">
                <el-select v-model="cancelForm.reason" placeholder="请选择作废原因" style="width:100%">
                  <el-option
                    v-for="item of reasonSet"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="详细说明：">
                <el-input type="textarea" v-model="cancelForm.reasontxt"></el-input>
              </el-form-item>
              <el-form-item label="上传附件：">
                <el-upload
                  action="#"
                  multiple
                  :show-file-list="false"
                  :file-list="enclosureFilesList"
                  :before-upload="enclosureFilesBeforeUpload"
                  :limit="30"
                  :on-exceed="enclosureFilesHandleExceed"
                  :on-error="enclosureFilesError"
                  style="margin-bottom:5px;"
                >
                  <el-button icon="el-icon-plus" size="small"></el-button>
                </el-upload>
                <!-- 附件列表 -->
                <div
                  class="enclosure-list-sty"
                  v-for="(item, index) in enclosureFilesList"
                  :key="index"
                >
                  <el-tooltip :content="item.fileName">
                    <p class="desc">{{ item.fileName }}</p>
                  </el-tooltip>
                  <span class="el-icon-error del-btn" @click="delEnclosureFiles(index)"></span>
                </div>
              </el-form-item>
              <el-form-item
                v-if="isInDingTalk || isCorp"
                label="审批流程："
                prop="approvalFlowSelect"
                style="width:100%"
              >
                <!-- 钉钉环境下审批流设置 -->
                <template v-if="isInDingTalk">
                  <el-tabs :stretch="true" v-model="flowType">
                    <!-- <el-tab-pane label="标准签" name="signStandard"></el-tab-pane> -->
                    <el-tab-pane label="选择审批流程" :name="flowTypes[0]" style="padding: 20px">
                      <flow-path @flowSelectChange="flowSelectChange"></flow-path>
                    </el-tab-pane>
                    <el-tab-pane label="自主选择审批人" :name="flowTypes[1]" style="padding: 20px">
                      <self-selection
                        :menbers="menbers"
                        @chooseMenber="chooseMenber"
                        @delUser="delUser"
                        @delLeven="delLeven"
                        @addLeven="addLeven"
                      ></self-selection>
                    </el-tab-pane>
                  </el-tabs>
                </template>
                <!-- 集团账户设置了审批流 （web端） -->
                <template v-else>
                  <el-select
                    v-model="cancelForm.approvalFlowSelect"
                    size="mini"
                    placeholder="请选择审批流程"
                    @change="handleChangeApprovalFlow"
                  >
                    <el-option
                      v-for="(v, index) in approvalFlowList"
                      :key="index"
                      :value="v.flowId"
                      :label="v.flowName"
                    ></el-option>
                  </el-select>
                  <div
                    v-if="flows.length > 0"
                    style="
                    border: 1px solid rgba(229, 229, 229, 1);
                    border-radius: 4px;
                    margin-top: 12px;
                    padding: 0 5px;
                  "
                  >
                    <span
                      v-for="(flow,i) of flows"
                      :key="i"
                    >{{flow.partyName}}{{i < flows.length-1 ? flow.hiddenArrow ? ' ->' : ' 、' : '' }}</span>
                  </div>
                </template>
              </el-form-item>
              <el-form-item label="意愿认证：" prop="authLevel">
                <el-radio-group v-model="cancelForm.authLevel">
                  <el-radio
                    v-for="flow of approvalSet"
                    :key="flow.value"
                    :label="flow.value"
                  >{{flow.label}}</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-form>
            <el-button type="primary" class="btn-sty" @click="cancelComfirm">发起作废协议</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <!--消费弹窗-->
    <el-dialog
      :visible.sync="priseVisibleDialog"
      title="温馨提示"
      :show-close="false"
      :close-on-click-modal="false"
      width="400px"
      class="prise-dialog"
    >
      <div class="box-dashed text-center" style="margin-top: 10px; padding-bottom: 5px">
        <img src="/images/icon_signed.png" style="height: 80px" />
        <template v-if="priseInfo.mealInfo">
          <h4>
            本次共花费：
            <span class="color-danger">{{ priseInfo.mealInfo }}</span>
          </h4>
          <h4 v-if="priseInfo.point">
            另需要支付
            <span class="color-danger">{{ priseInfo.point }}积分</span>
          </h4>
        </template>
        <h4 v-else style="font-weight: bold">
          本次共花费：
          <span class="color-danger">{{ priseInfo.point }}积分</span>
        </h4>
        <p style="text-align: start; margin-left: 8px">
          <i class="el-icon-info"></i>
          发起后，签署方将收到签署短信通知，该通知72小时有效，请尽快完成签署！
        </p>
      </div>
      <div slot="footer" class="text-center">
        <el-button
          @click="toPay()"
          type="danger"
          size="small"
          class="footer-btn"
          :disabled="payDisabled"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { isInDingTalk } from "@/assets/js/utils/ding-env";
// components
import contract from "./components/contract.vue"; // 合同组件
import Flow from "../../../components/flow/index.vue";
import flowPath from "../../initiation/components/dingTalkuse/flowPath.vue";
import selfSelection from "../../initiation/components/dingTalkuse/selfSelection.vue";
// API
import {
  postMultipleCreateApply,
  postFileTempUpload,
  ApiMethods,
} from "@/assets/js/http-serve/http-methods";
import { ApiCorpMethods } from "@/assets/js/http-serve/corp/http-methods";
import { dingtalkApi } from "@/assets/js/http-serve/dingtalkApi";
import { mapGetters } from "vuex";
import moment from 'moment'
// ⚠️ dingtalk-jsapi 只能在客户端（浏览器）中使用
let dd = null;
if (process.client && isInDingTalk) {
  dd = require('dingtalk-jsapi');
}
export default {
  components: { contract, Flow, flowPath, selfSelection },
  data () {
    // 这里存放数据
    return {
      payDisabled: false,
      // 显示价格的弹窗
      priseInfo: { mealInfo: null, money: 0, point: 0, cashierUrl: "" },
      priseVisibleDialog: false,
      payInfoData: {},
      // 钉钉环境使用变量 start
      isInDingTalk,
      flowTypes: ["flow_path", "self_selection"], // 钉钉环境下审批类型列表
      flowType: "flow_path", // 钉钉环境下选择的审批类型
      flowList: [], // 审批列表
      menbers: [{ appleven: 1, menber: [] }], // 审批自选
      flowSelect: [], // 审批流程shen
      // 钉钉环境使用变量 end
      approvalFlowList: [],
      flows: [],
      enclosureFilesList: [],
      loading: null,
      cancelForm: {
        reason: '',
        reasontxt: '',
        approvalFlowSelect: '',
        authLevel: -1
      },
      rules: {
        reason: [
          { required: true, message: '请选择作废原因', trigger: 'change' }
        ],
        authLevel: [{ required: true, message: '请选择认证意愿', trigger: 'change' }],
        approvalFlowSelect: [{ validator: this.validateFlow, trigger: 'change' }]
      },
      /** 作废原因 */
      reasonSet: [
        { label: '合同终止', value: 1 },
        { label: '印章错误', value: 2 },
        { label: '合同条款有误', value: 3 },
        { label: '签约方信息有误', value: 4 },
        { label: '其他', value: 5 },
      ],
      /** 审批流程 */
      approvalSet: [
        { label: '无认证', value: -1 },
        { label: '人脸识别', value: 11 },
      ],
      INVALI: {}
    }
  },
  // 监听属性 类似于data概念
  computed: {
    ...mapGetters(["currentAuthUser", "allAuthUser"]),
    isCorp () {
      const corp = this.currentAuthUser.corpUserId;
      console.log('corp', !!corp);
      return !!corp
    },
  },
  // 方法集合
  methods: {
    /** 审批流程校验逻辑 */
    validateFlow (rule, value, callback) {
      const tipText = '请选择审批流程', tipText2 = '请选择审批人员';
      if (isInDingTalk) {
        // 钉钉环境
        (this.flowType === this.flowTypes[0] && this.flowSelect.length === 0) ? callback(new Error(tipText)) : callback();
        if (this.flowType === this.flowTypes[1] && this.flowSelect.length === 0) {
          let nodes = [];
          this.menbers.forEach(item => {
            //  拿到每层的人列表
            const userList = item.menber;
            let userApproveUsers = [];
            userList.forEach(elem => {
              userApproveUsers.push({
                name: elem.name,
                userId: elem.emplId
              });
            });
            if (userApproveUsers.length > 0) nodes.push({ userApproveUsers });
          });
          // 这里 nodes 是 选择审批人用的判断
          nodes && nodes.length == 0 ? callback(new Error(tipText2)) : callback();
        }
        callback()
      } else {
        // saas环境
        value === '' ? callback(new Error(tipText)) : callback();
      }
    },
    /** 发起作废 */
    async cancelComfirm () {
      this.$refs.cancelFormRef.validate(async valid => {
        if (!valid) return;
        /** 作废协议预创建 */
        this.loadingStart();
        // 作废协议预创建
        const param = {
          applyId: this.INVALI.applyId,
          reason: this.reasonSet.find(item => item.value === this.cancelForm.reason).label,
          reasontxt: this.cancelForm.reasontxt,
        }
        ApiMethods.ApplySignController.applySignTermination(param).then(async res => {
          if (!res.success) {
            this.loadingClose();
            return this.$message.error(res.description || "作废协议创建失败")
          }
          const flowInfo = await this.getFlowUserInfo();
          // 钉钉环境就走钉钉逻辑
          if (isInDingTalk) return this.createPreApproved(flowInfo, res.data);
          // 2.将预创建的协议id传入到作废协议发起接口
          (!isInDingTalk && this.isCorp) ? this.corpCreateApply(res.data) : this.createApply(res.data)
        }).finally(()=>this.loadingClose())
      });
    },
    /** 作废协议发起接口 */
    async createApply (data) {
      const param = data ? await this.paramsConfig(data) : Object.assign(this.payInfoData.param, { pay: 1 }),
        { multiFileKey } = this.$route.query;
      if (multiFileKey) param.multiFileKey = multiFileKey;
      postMultipleCreateApply(param).then(res => {
        if (+res.code === 0) {
          sessionStorage.removeItem('NeedToBeInvalidated')
          this.createdFinish({ data: res.data, batch: {}, param })
          return;
        }
        if (+res.code === 10806) {
          this.$jzqService.pointRechargeTip(); // 积分不足时的充值提示
        }
        this.$message.error(res.description || "支付失败");
      }).catch(err => {
        if (+err.code === 10806) {
          this.$jzqService.pointRechargeTip(); // 积分不足时的充值提示
        }
        this.payDisabled = false;
      }).finally(err => {
        this.payDisabled = false;
        this.loadingClose();
      });;
    },
    /** 协议接口参数创建 */
    paramsConfig (data) {
      const _data = JSON.parse(JSON.stringify(data));
      const { signs, imgsData: _img } = _data
      const signers = JSON.parse(JSON.stringify(signs))
      signers && signers.forEach(item => {
        // 意愿认证参数添加到每个签署主体
        if (this.cancelForm.authLevel !== -1) item.authLevel = this.cancelForm.authLevel || null
        item.corpUserStatus = false
        item.faceOrVideo = null
        item.idCardNoShow = false
        item.isEncrypt = false
        item.ischange = 1
        item.openUserTab = false
        item.readTime = null
        item.signLevel = 1
        item.signatoryUserType = 0
        item.videoSignUserType = ""
        item.signOwner = item.signNum
        item.chapteJson = JSON.parse(item.chapteJson)
        item.account = item.signatoryEmai || item.signatoryMobile
        item.identityNo = item.identityCard
        item.chapteJson.forEach(chap => {
          chap.chaptes && chap.chaptes.forEach(j => {
            j.targetId = _img.tempFile.targetId
            j.qsInfo = item.name
            j.userType = item.userType
            j.signOwner = item.signNum
            j.signatoryUserType = item.userType
          })
        })
      })
      const _FILE = {
        fileName: _img.fileName || '作废协议.pdf',
        fileOperVO: {
          docHash: _img.docHash,
          fileName: _img.fileName || '作废协议.pdf',
          // fileSize: _img.size || '',
          fileType: 3,
          sign: _img.tempFile.sign,
          targetId: _img.tempFile.targetId,
          ts: _img.tempFile.ts,
        },
        tempFile: _img.tempFile,
        fileType: 1,
        items: _img.items,
        sort: 0
      }
      const params = {
        applyIdSec: "",
        batchSignOrder: 0,
        batchSigners: [],
        carbonCopy: [],
        consumMode: 0,
        contractName: _data.contractName,
        draftChapteJson: [],
        hideSignDate: 0,
        ifOrder: false,
        needPresSign: 1,
        needQifengSign: 2,
        needVideoSign: 0,
        newNeedVideoSign: 0,
        overDate: "",
        pay: 0,
        saveToDraftBox: false,
        serverCa: 1,
        signExpire: moment().add(3, "days").format("YYYY-MM-DD HH:mm:ss"),
        signers,
        videoSignStartTime: "",
        terminationApplyId: this.INVALI.applyId,
        files: [_FILE, ...this.enclosureFilesList],
      }
      return params
    },
    /** 成员身份发起 */
    async corpCreateApply (data) {
      const param = await this.paramsConfig(data)
      if (isInDingTalk) {
        // dingTalkWorkFlowId 如果有这个参数，把参数带入进去。且发起完成后创建钉钉审批流
        const { dingTalkWorkFlowId, dingTalkCorpId, dingTalkUserId } = data;
        param.dingTalkCorpId = dingTalkCorpId;
        param.dingTalkUserId = dingTalkUserId;
        param.dingTalkWorkFlowId = dingTalkWorkFlowId;
      } else {
        param.flowId = this.cancelForm.approvalFlowSelect
        if (+param.flowId === 0) {
          delete param.flowId;
        }
      }
      ApiCorpMethods.CorpApplyContractController.multipleCreate(Object.assign(param, { pay: 1 })).then(res => {
        if (res.code === "0") {
          sessionStorage.removeItem('NeedToBeInvalidated')
          if (!isInDingTalk) this.createdFinish({ data: res.data, batch: {}, param })
          if (isInDingTalk) {
            // 如果是钉钉微应用使用。就在去创建审批流程
            const _this = this;
            dingtalkApi.contractCreate({
              corpId: param.dingTalkCorpId,
              dingTalkUserId: param.dingTalkUserId,
              preWorkFlowId: param.dingTalkWorkFlowId
            }).then(dingFlowRes => {
              if (!dingFlowRes.success) return _this.$message.error(dingFlowRes.description);
              this.createdFinish({ data: res.data, batch: {}, param })
            });
          }
        } else {
          this.loadingClose();
          this.$message.error(
            res.description || "签署失败，请刷新后再试"
          );
        }
      }).finally(err => {
        this.loadingClose();
      });
    },
    /** 发起完成之后回掉函数 */
    createdFinish ({ data, batch, param }) {
      const snapshotId = data.snapshotId || "";
      this.payInfoData = {
        batch: batch,
        param: param,
        recharge: data.recharge,
        snapshotId: snapshotId
      };
      this.loadingClose();
      (!data.needPay || [false, 'false'].includes(data.needPay)) ? this.NotPayFun({ data, batch, param }) : this.PayFun({ data, batch, param })
    },
    /** 需要支付 */
    PayFun ({ data, batch, param }) {
      if (this.payInfoData.recharge) return this.$jzqService.pointRechargeTip(data); // 积分不足时的充值提示
      this.priseInfo.cashierUrl = data.cashierUrl || "";
      // this.priseInfo.money = data.money;
      this.priseInfo.point = data.point;
      // 打开需要支付弹窗
      this.priseVisibleDialog = true;
      const { moneyData } = data, NotEmpty = Object.keys(moneyData).length > 0
      if (NotEmpty) {
        let moneryArr = [];
        const { applySign, bankFour, bankThree, face } = moneyData, attrKeys = Object.keys(moneyData);
        attrKeys.forEach(keyName => {
          switch (keyName) {
            // 签署次数
            case 'applySign':
              applySign.timesPackage && moneryArr.push(`签署${applySign.timesPackage}次`);
              break;
            // 银行卡4要数次数
            case 'bankFour':
              bankFour.timesPackage && moneryArr.push(`四要素${bankFour.timesPackage}次`);
              break;
            // 3要数次数
            case 'bankThree':
              bankThree.timesPackage && moneryArr.push(`三要素${bankThree.timesPackage}次`);
              break;
            // 人脸次数
            case 'face':
              face.timesPackage && moneryArr.push(`人脸${face.timesPackage}次`);
              break;
            default:
              break;
          }
        })
        if (moneryArr && moneryArr.length > 0) this.priseInfo.mealInfo = moneryArr.join("；");
      }
    },
    /** 无需支付 */
    NotPayFun ({ data, batch, param }) {
      this.$message.success("作废协议发起成功！");
      const flow = param.dingTalkWorkFlowId || data.selfSign === 2, self = data.selfSign === 1, arrproveList = this.isCorp ? '4' : '2';
      const CorpPath = `/corp/signInfo/signList?signStatus=${flow ? '5' : self ? '4' : arrproveList + '&mySendTo=1'}`,
        selfPath = flow ? "/corp/signInfo/signList?signStatus=5" : `/signInfo/signList?signStatus=${self ? '2' : arrproveList + '&mySendTo=1'}`;
      console.log('this.isCorp ? CorpPath : selfPath', this.isCorp ? CorpPath : selfPath);
      //有审批的 [isCorp]
      this.$router.push({ path: this.isCorp ? CorpPath : selfPath });
    },
    /** 前往支付 */
    async toPay () {
      this.payDisabled = true;
      this.createApply()
    },
    // 新增附件文件上传
    enclosureFilesBeforeUpload (file) {
      const isLt20M = file.size / 1024 / 1024 < 20;
      if (this.enclosureFilesList.length >= 30) return this.$message.error("当前可上传的文件不能超过30个！");
      if (!isLt20M) return this.$message.error("上传文件大小不能超过 20M!");
      this.loadingStart("文件上传中~");
      postFileTempUpload({ file: file, fileType: 1 })
        .then(data => {
          this.loadingClose();
          const resInfo = {
            fileName: data.file.name,
            fileOperVO: {
              fileName: data.file.name,
              fileSize: data.file.size,
              fileType: 3,
              sign: data.tempFile.sign,
              targetId: data.tempFile.targetId,
              ts: data.tempFile.ts
            },
            tempFile: data.tempFile,
            fileType: 2,
            sort: 0
          };
          this.enclosureFilesList.push(resInfo);
        })
        .catch(err => {
          this.loadingClose();
          this.$message.warning(err.description || "附件上传失败请重试");
        });
    },
    /** 超出限制事件 */
    enclosureFilesHandleExceed (files, fileList) {
      return this.$message.error(
        `当前限制选择 30 个文件，本次选择了 ${files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    // 删除已上传的附件
    delEnclosureFiles (index) {
      this.enclosureFilesList &&
        this.enclosureFilesList.length &&
        this.enclosureFilesList.splice(index, 1);
    },
    enclosureFilesError (err) {
      console.log(err);
      this.loadingClose();
    },

    // * 钉钉相关逻辑 start
    /** 创建预审批流 */
    createPreApproved (flowInfo, paramInfo) {
      const { dingTalkCorpId: corpId, dingTalkUserId } = JSON.parse(sessionStorage.getItem("dingloginInfo")),
        _this = this;
      const data = {
        corpId,
        dingTalkUserId,
        ...flowInfo
      };
      dingtalkApi.precreate(data).then(res => {
        console.log("预审批流创建流程", res);
        if (!res.success && res.code !== '18001') return _this.$message.error(res.description);
        if (res.code === '18001') {
          return _this.$confirm(
            `
              <p>${res.description}</p>
              <p style="color:#ec1c1c">
                （如您选择的是同步钉钉组织架构模式，请在钉钉组织架构中维护部门主管信息，若选择的是自行管理组织架构，
                请在企业控制台-组织及权限菜单，维护部门主管信息）
              </p>
            `, 
            '提示',
            {
            distinguishCancelAndClose: true,
            confirmButtonText: '添加审批人',
            cancelButtonText: '跳过主管审批',
            dangerouslyUseHTMLString: true
          }).then(() => {
            // 添加审批人
            this.chooseApproval(flowInfo, paramInfo)
          }).catch((type) => {
            if(type === 'cancel'){
              _this.createPreApproved({...flowInfo,ignoreGroupManager:1}, paramInfo)
            }
          })
        }
        // 预审批流程创建完成后发起合同，发起成功创建审批流
        const params = {
          dingTalkWorkFlowId: res.data,
          dingTalkCorpId: corpId,
          dingTalkUserId
        };
        // 发起作废
        this.corpCreateApply({ ...paramInfo, ...params })
      });
    },
    /** 发起时选择审批人 */
    chooseApproval(flowInfo, paramInfo){
      const corpId=sessionStorage.getItem("corpId");
      dd.complexChoose({
        maxUsers:1,
        corpId,
        multiple:false,
        pickedUsers:[],
        disabledUsers:[],
        responseUserOnly:true,
        success:res=>{
          if(res.selectedCount>0){s
          const user=res.users[0];
          const _flowObj = {...flowInfo,userSelectManagerId:user.emplId}
          // 选择成功后重新发起
          this.createPreApproved(_flowObj, paramInfo)
          }
        },
      }).catch((err)=>{console.log("catch_err:",err) });
    },
    /** 选择的审批流程 */
    flowSelectChange (flow) {
      this.flowSelect = flow;
      const ccUser = flow[0].webCCUsers
      ccUser.forEach(user => {
        user.corpUserIdSec = user.corpUserIdApplySign
      })
      // this.arrayCopior = ccUser
    },
    /** 鉴权 + 选人 */
    chooseMenber ({ index: i, isManager }) {
      if (isManager) return this.addManager(i)
      const corpId = sessionStorage.getItem("corpId");
      const len = this.menbers.length;
      let max = 1,
        users = [];
      if (len > 1) max = 1;
      if (len === 1) max = 20;
      this.menbers.forEach(item => {
        const mens = item.menber;
        const menIds = mens.map(elem => {
          return elem.emplId;
        });
        users.push(...menIds);
      });
      dd.complexChoose({
        maxUsers: max,
        corpId,
        multiple: len > 1 ? false : true,
        pickedUsers: len === 1 ? users : [],
        disabledUsers: [],
        responseUserOnly: true,
        success: res => {
          console.log('res_choose', res);
          let _menber = this.menbers[i].menber
          const _newMen = _menber.filter(item => item.emplId === '-1')
          this.menbers[i].menber = [..._newMen, ...res.users];
        },
      }).catch((err) => { console.log("catch_err:", err) });
    },
    /** 添加直属部门主管 */
    addManager (i) {
      const _men = this.menbers[i].menber;
      const haveAss = _men.some(item => item.emplId === '-1')
      if (haveAss) return this.$message.error('审批人不能重复')
      this.menbers[i].menber.push({ name: '部门直属主管', emplId: '-1' })
    },
    /** 删除层级 */
    delLeven (i) {
      this.menbers.splice(i, 1);
    },
    /** 删除审批人 */
    delUser (leven, user) {
      const mens = this.menbers[leven].menber;
      mens.forEach((item, i) => {
        if (item.emplId === user.emplId) {
          mens.splice(i, 1);
        }
      });
    },
    /** 添加审批层级 */
    addLeven () {
      let len = this.menbers.length;
      this.menbers.push({ appleven: ++len, menber: [] });
    },
    // 获取审批人信息
    getFlowUserInfo () {
      let nodes = [],
        _this = this;
      let info = {};
      // 自主选择
      if (this.flowType === this.flowTypes[1]) {
        _this.menbers.forEach(item => {
          //  拿到每层的人列表
          const userList = item.menber;
          let userApproveUsers = [];
          userList.forEach(elem => {
            userApproveUsers.push({
              name: elem.name,
              userId: elem.emplId
            });
          });
          if (userApproveUsers.length > 0) nodes.push({ userApproveUsers });
        });
        // 这里 nodes 是 选择审批人用的判断
        console.log("nodes", nodes);
        if (nodes && nodes.length == 0) {
          _this.$message.error("请选择审批人员");
          return false;
        }
      }
      if (this.flowType === this.flowTypes[0]) {
        const flowArr = this.flowSelect
        nodes = flowArr.length ? flowArr[0].nodes : [];
      }
      info = {
        ccUsers: [],
        nodes
      };
      return info;
    },
    // * 钉钉相关逻辑 end
    // * web 成员审批流逻辑 start
    handleChangeApprovalFlow (val) {
      let params = {};
      params.flowId = val;
      ApiCorpMethods.CorpAuditContractController.preFlowInst(params)
        .then(res => {
          if (res.code === "0") {
            // convert form data
            if (res.data) {
              let data = res.data;
              // flow
              this.flows = data.partyList ? data.partyList : [];
              // this.arrayCopior = [];
              // if (data.copyToList) {
              //   (data.copyToList || []).forEach(i => {
              //     i.hideRemove = true;
              //     this.arrayCopior.push(i);
              //   });
              // }
              if (data.orderFlag === 1) {
                this.flows.forEach((element, index) => {
                  if (this.flows.length - 1 !== index) {
                    element.hiddenArrow = true;
                  } else {
                    element.hiddenArrow = false;
                  }
                });
              } else {
                this.flows.forEach((element, index) => {
                  element.hiddenArrow = false;
                });
              }
            }
          } else {
            this.$message.error(res.description);
          }
        })
        .catch(error => {
          this.$message.error(error.description);
        });
    },
    // 判断集团账户是否有审批流
    hasApprovalFlow () {
      // 查询发起审批流
      let params = {
        itemPage: 1,
        pageSize: 100,
        flowType: 0 // 流程类型 0审批流程 1用章流程
      };
      ApiCorpMethods.CorpAuditContractController.pageFlow(params)
        .then(res => {
          if (res.code === "0") {
            this.approvalFlowList = res.data;
          } else {
            this.$message.error(res.description || "查询审批流程数据失败");
          }
        })
        .catch(error => {
          this.$message.error(error.description || "查询审批流程数据失败");
        });
    },
    // * web 成员审批流逻辑 end
    loadingStart (info = null) {
      this.loading = this.$loading({
        lock: true,
        text: info || "正在拼命加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, .5)"
      });
    },
    //设置状态
    loadingClose () {
      if (this.loading) {
        this.loading.close();
        this.loading = null;
      }
    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {
    // 先获取到需要作废协议的基本信息
    this.INVALI = JSON.parse(sessionStorage.getItem('NeedToBeInvalidated'));
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
    // 不做审批流程查询
    if (this.isCorp) this.hasApprovalFlow();
  },
}
</script>
<style lang='less' scoped>
// @import url(); 引入公共css类
.cancel-root {
  @contentHeight: 77vh;
  background-color: #fff;
  height: 84vh;
  padding-top: 10px;
  .title {
    font-size: 0.7vw;
    font-weight: bolder;
    display: flex;
    align-items: center;
    &::before {
      content: "";
      display: inline-block;
      width: 5px;
      height: 15px;
      background: #262626;
      border-radius: 100px;
      margin-right: 0.5vw;
    }
  }
  .contract-sty {
    padding: 10px;
    .right-contract-box {
      border: 1px solid #ccc;
      padding: 2vh 2vw 1vh 2vw;
      height: @contentHeight;
    }
    .left-input-box {
      padding: 10px;
      border: 1px solid #ccc;
      height: @contentHeight;
      .form-sty {
        height: 93%;
        overflow-y: auto;
      }
      .btn-sty {
        width: 100%;
      }
    }
  }
  .enclosure-list-sty {
    display: flex;
    align-items: center;
    border-radius: 4px;
    box-shadow: 0 0 1px 0 #8f8f8f;
    background-color: #ccc;
    padding: 0 5px;
    margin-bottom: 5px;
    .desc {
      width: 90%;
      overflow: hidden; /* 隐藏溢出的内容 */
      text-overflow: ellipsis; /* 溢出内容显示为省略号 */
      white-space: nowrap; /* 文本不换行 */
    }
  }
}
</style>


// WEBPACK FOOTER //
// pages/initiation/invalidation/cancellation.vue